import { Device, Theme } from '@livecontrol/core-ui';
import { DateTime } from 'luxon';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Panel } from '../../components';
import { useRouteHistory } from '../../store';
import { AssetDetailsLayout } from './components';

export const AssetDetails = (): React.ReactElement => {
  const history = useHistory();
  const { prevPathname } = useRouteHistory();
  const viewport = Theme.useViewport();

  const padding = `py-8px px-${
    Device.isDesktop(viewport) ? 64 : Device.isTablet(viewport) ? 32 : 16
  }px`;

  return (
    <div className={padding}>
      <div className='p-12px d-flex justify-content-between'>
        <button
          type='button'
          className='x-pseudo text-white40'
          onClick={(): void => {
            if (prevPathname) {
              history.goBack();
            } else {
              history.replace('/events');
            }
          }}
        >
          <i className='fas fa-long-arrow-left mr-16px' />
          Back to Dashboard
        </button>

        <div className='text-white40 text-nowrap'>
          <span className='font-weight-bold'>Time Zone:</span> {DateTime.local().toFormat('z')}
        </div>
      </div>
      <Panel>
        <AssetDetailsLayout />
      </Panel>
    </div>
  );
};
